import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { institutionsProgramIdSelectors } from '@ucheba/store/institutions/programs/programId'

export const usePaidPackage = (): boolean => {
  const program = useSelector(institutionsProgramIdSelectors.entity)

  return useMemo(() => {
    if (program) {
      const paidPackage =
        program?.faculty?.paidPackage || program?.institution?.paidPackage

      return !!paidPackage && paidPackage.id !== 17
    }

    return false
  }, [program])
}
